import { render, staticRenderFns } from "./VaccinationAnalysisTableHeader.vue?vue&type=template&id=4704a6b2&scoped=true&"
import script from "./VaccinationAnalysisTableHeader.vue?vue&type=script&lang=ts&"
export * from "./VaccinationAnalysisTableHeader.vue?vue&type=script&lang=ts&"
import style0 from "./VaccinationAnalysisTableHeader.vue?vue&type=style&index=0&id=4704a6b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4704a6b2",
  null
  
)

export default component.exports